
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("1qPDV", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $10b0475ecc2a394e$export$2cd8252107eb640b; });

var $jG4hL = parcelRequire("jG4hL");

var $i9AjL = parcelRequire("i9AjL");
// -------------------------------------------------------------------
// import CSS via f:asset
// -------------------------------------------------------------------
const $10b0475ecc2a394e$var$players = {};
const $10b0475ecc2a394e$var$plyrOptions = {
    iconUrl: "/typo3conf/ext/as_template/Resources/Public/Vendor/Plyr/plyr.svg",
    blankVideo: "/typo3conf/ext/as_template/Resources/Public/Vendor/Plyr/blank.mp4",
    youtube: {
        noCookie: true
    }
};
const $10b0475ecc2a394e$var$initVideo = (id, inModal, delayed)=>{
    let hashID = "#" + id;
    let $box = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(`[data-target="${id}"]`);
    let player = new (0, (/*@__PURE__*/$parcel$interopDefault($i9AjL)))(hashID, $10b0475ecc2a394e$var$plyrOptions);
    player.on("ready", function(event) {
        let iPlayer = event.detail.plyr;
        $10b0475ecc2a394e$var$players[iPlayer.media.id] = event.detail.plyr;
        iPlayer.on("playing", (event)=>{
            $box.addClass("playing");
            $box.find(".video-play-button").removeClass("loading");
        });
        iPlayer.on("pause", (event)=>$box.removeClass("playing"));
        iPlayer.on("ended", (event)=>$box.removeClass("playing"));
        $box.removeClass("loading");
        if (inModal) {
            $box.find(".modal").on("show.bs.modal", function(e) {
                let mPlayer = $10b0475ecc2a394e$var$players[id];
                mPlayer.play();
            });
            $box.find(".modal").on("hide.bs.modal", function(e) {
                let mPlayer = $10b0475ecc2a394e$var$players[id];
                mPlayer.play();
            });
        }
        if (delayed) iPlayer.play();
    });
    if (delayed) $box.addClass("init");
};
const $10b0475ecc2a394e$var$videoSetup = (className)=>{
    if (className !== "local") {
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body").removeClass(`${className}No`);
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(`.video-play-button.${className}`).css("display", "block");
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(`.js-player.${className}`).each(function() {
        let $box = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).parents(".video-box");
        $box.addClass("loading");
        if ($box.hasClass("init")) {
            let player;
            if ($box.find("video").length > 0) player = $10b0475ecc2a394e$var$players[$box.find("video").attr("id")];
            else player = $10b0475ecc2a394e$var$players[$box.find("iframe").attr("id")];
            player.play();
        } else $10b0475ecc2a394e$var$initVideo($box.attr("data-target"), false, false);
    // Modal variant
    // let $target = $box.find(".video-play-button");
    // $target.on("click", function (e) {
    //   $target.addClass("loading");
    //   if ($box.hasClass("init")) {
    //     let player;
    //     if ($box.find("video").length > 0) {
    //       player = players[$box.find("video").attr("id")];
    //     } else {
    //       player = players[$box.find("iframe").attr("id")];
    //     }
    //     player.play();
    //   } else {
    //     initVideo($target.attr("data-target"), false, true);
    //   }
    // });
    });
};
const $10b0475ecc2a394e$var$audioSetup = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".js-player.audio").each(function(e) {
        new (0, (/*@__PURE__*/$parcel$interopDefault($i9AjL)))(`#${(0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).attr("id")}`, $10b0475ecc2a394e$var$plyrOptions);
    });
};
const $10b0475ecc2a394e$var$checkExternlPlayerSetup = ()=>{
    if (typeof UC_UI !== "undefined") {
        let ytc = UC_UI.getServicesBaseInfo().find((data)=>data.id === "BJz7qNsdj-7"); // Youtube
        let vc = UC_UI.getServicesBaseInfo().find((data)=>data.id === "HyEX5Nidi-m"); // Vimeo
        if (ytc && ytc.consent.status) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body").removeClass("noYoutube");
            $10b0475ecc2a394e$var$videoSetup("youtube");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body").addClass("noYoutube");
        if (vc && vc.consent.status) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body").removeClass("noVimeo");
            $10b0475ecc2a394e$var$videoSetup("youtube");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body").addClass("noVimeo");
    } else setTimeout(function() {
        $10b0475ecc2a394e$var$checkExternlPlayerSetup();
    }, 500);
};
const $10b0475ecc2a394e$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    $10b0475ecc2a394e$var$videoSetup("local");
    $10b0475ecc2a394e$var$audioSetup();
    // if document.ready needed
    const whenComplete = ()=>{
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") {
            $10b0475ecc2a394e$var$checkExternlPlayerSetup();
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".uc-inner-notice button").on("click", function() {
                $10b0475ecc2a394e$var$checkExternlPlayerSetup();
            });
        } else setTimeout(function() {
            whenComplete();
        }, 400);
    };
    whenComplete();
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$581ff339ea0ba762; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
function $3d624443cd99befe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$4fa2f4023c9cbda5; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=asVideo.module.7e9ffe91.js.map
